RivalIQ.apps.SocialChannelMatrix.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.LandscapeEmailControl = RivalIQ.views.ItemView.extend({
        template: '#landscapeEmailControlTemplate',

        ui: {
            checkboxes: '[type="checkbox"]',
            save: '.x-save'
        },

        eventsNotToDebounce: {
            'click @ui.save': 'onSave',
            'click .x-check': 'checkAll',
            'click .x-uncheck': 'uncheckAll'
        },

        loadData: function (callback) {
            const me = this;

            RivalIQ.data.landscapes.fetch().done(function (landscapes) {
                me.collection = landscapes;
                callback();
            });
        }
    });

    views.MatrixListRow = RivalIQ.views.LayoutView.mixin({
        ui: {
            icon: 'img',
            company: '.x-company-name',
            suggestNameChangeMenuItem: '.x-suggest-name-change',
            removeMenuItem: '.x-remove-company',
            tooltips: '[data-toggle="tooltip"]'
        },

        regions: {
            twitter: '.x-has-twitter',
            facebook: '.x-has-facebook',
            youtube: '.x-has-youtube',
            instagram: '.x-has-instagram',
            tiktok: '.x-has-tiktok'
        },

        events: {
            'click @ui.suggestNameChangeMenuItem': 'onSuggestNameChangeClicked',
            'click @ui.removeMenuItem': 'onRemoveClicked'
        },

        tagName: 'tr',
        template: '#matrixListRowTemplate',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        pollingDelay: 5000,
        pollingMaxAttempts: 60,

        initialize: function (options) {

            const me = this;
            const opts = options || {};
            _.extend(me, _.pick(opts, 'companyData'));
        },

        className: function () {

            const me = this;
            const classNames = ['text-center'];

            return (me.model.id === RivalIQ.state.view.get('focusCompanyId') ?
                classNames.concat(['focus-company']) :
                classNames).join(' ');
        },

        templateHelpers: function () {
            const me = this;
            const data = me.model.toJSON();
            const isFocusCompany = data.id === RivalIQ.state.view.get('focusCompanyId');
            const excludedCompanyIds = _.get(RivalIQ.state.landscape.get('auditSettings'), 'excludedCompanyIds', []);
            const isNotEditable = _.includes(excludedCompanyIds, data.id);

            let companyProfileUrl = ['/company', data.id].join('/');
            // NOTE only for a Social Channel Matrix hosted in the companies
            // curation (🙄) should we show a link back in company profiles
            const curationId = _.get(me, ['dashboardModel', 'curation', 'id']);
            if (curationId === RivalIQ.enums.curation.COMPANIES) {
                companyProfileUrl = [
                    companyProfileUrl,
                    ['from', curationId].join('=')
                ].join('?');
            }

            return {
                iconUrl: RivalIQ.utils.companyDisplay.getIcon(data),
                abbr: RivalIQ.utils.companyDisplay.getAbbreviation(data),
                domain: me.getDomain(),
                isFocusCompany: isFocusCompany,
                sources: RivalIQ.enums.sourceMask,
                is1xux: me.options.is1xux,
                isNotEditable: isNotEditable,
                channelAccess: function (channel) {
                    return RivalIQ.state.landscape.channelAccess(channel);
                },
                channelSupported: function (channel) {
                    return RivalIQ.state.account.channelSupported(channel);
                },
                companyProfileUrl: companyProfileUrl,
                showRemove: me.getOption('showRemoveAction') !== false,
                showActions: !me.getOption('hideActions') && RivalIQ.state.user.can('update', RivalIQ.state.landscape)
            };
        },

        getDomain: function () {
            const me = this;
            const domain = me.model.get('domain');
            return (domain || '').replace(/https?:\/\/(www\.)?/, '').replace(/\/$/, '');
        },

        onSuggestNameChangeClicked: function () {

            const me = this;
            const model = me.model;

            const modal = new RivalIQ.suggestion.views.Modal({
                model: new Backbone.Model({
                    companyId: model.id,
                    companyName: model.get('name'),
                    channelHandle: null,
                    decoratedHandle: null,
                    source: RivalIQ.data.CompareData.sources.RIVALIQ
                })
            });

            me.listenToOnce(modal, 'submit', me.onNameChangeRequest);

            RivalIQ.apps.Shell.execute('show:modal', modal);
        },

        onNameChangeRequest: function (didEdit) {
            const me = this;

            if (didEdit) {
                me.onUserEdit();
            }
        },

        onRemoveClicked: function () {

            const me = this;

            function removeCompany() {
                me.$el.velocity('fadeOut', {
                    duration: 500,
                    complete: function () {

                        me.trigger('unfollowed');
                    }
                });
            }

            // NOTE, this puts a dependency on ES for unfollowing companies; maybe the failure scenario here should
            // be to just unfollow the company.
            $.ajax({
                url: `/api/landscape/${RivalIQ.state.landscape.id}/company/${me.model.get('id')}/taggedPostCount`,
                type: 'GET',
                success: function (taggedPostCount) {

                    let modalText = '';

                    if (taggedPostCount > 0) {
                        modalText = `Removing this company will untag ${RivalIQ.formatter.formats.number(taggedPostCount)} ${RivalIQ.formatter.numericLabel('post', 'posts', taggedPostCount)} and cannot be undone. `;
                    }

                    modalText += 'If this company is unique to this landscape it will no longer be tracked and the audience history may be deleted.';

                    const modalInfo = {
                        information: {
                            title: `Remove "${me.model.get('name')}" from this landscape?`
                        },
                        contentHtml: modalText,
                        actions: [
                            {
                                html: 'Cancel',
                                className: 'btn btn-default',
                                attributes: {
                                    type: 'button',
                                    'data-dismiss': 'modal'
                                }
                            },
                            {
                                html: 'Confirm Remove',
                                className: 'btn btn-danger',
                                events: {
                                    click: removeCompany
                                },
                                attributes: {
                                    type: 'button',
                                    'data-dismiss': 'modal'
                                }
                            }
                        ]
                    };
                    RivalIQ.execute('show:modal', modalInfo);
                }
            });
        },

        onRender: function () {

            const me = this;

            me.ui.icon.one('error', me.onCompanyIconLoadingError);

            _.each(me.getOption('channels'), function (channel) {
                me.showColumn(channel);
            });
            me.initializePolling();
            me.ui.tooltips.tooltip({
                container: 'body',
                delay: {
                    show: 500,
                    hide: 100
                }
            });
        },

        onCompanyIconLoadingError: function () {

            $(this).addClass('x-unavailable');
        },

        onUserEdit: function () {

            const me = this;
            let once = true;

            const userEdit = me.pollCompanyUntilCondition(function () {
                if (once) {
                    App.trigger('userEdit:start');
                    once = false;
                }
                return !me.model.stillWaitingForUserEdit();
            }, {
                skipFailFast: true
            });

            userEdit.done(function () {
                App.trigger('userEdit');

                me.requestRenderedFrame(function () {
                    // re-render to pick up any potential icon changes.
                    // Use baseRender as we don't want the parent view's async render logic to kick in.
                    me.baseRender();
                });
            });
        },

        showColumn: function (channel) {

            const me = this;

            const view = new views.MatrixListItem({
                is1xux: me.options.is1xux,
                model: new Backbone.Model({
                    channel: channel,
                    company: me.model
                })
            });

            // listen for user edits from each of the list items
            me.listenTo(view, 'userEdit', me.onUserEdit);

            me[channel.matrixListRowUIKey].show(view);
        },

        initializePolling: function () {

            const me = this;

            if (App.isExport) {

                return;
            }

            if (me.model.stillFinding()) {

                me.pollForFinderUpdates()
                    .done(_.bind(me.onFinderComplete, me));

            } else if (me.model.stillWaitingForUserEdit()) {
                me.onUserEdit();
            }
        },

        handleFailures: function (error) {

            const me = this;
            let message = null;

            if (error.type === 'max-attempts') {

                message = 'matrixListRow: max polling attempts exceeded';
            } else {

                message = error.message || error.statusText;
            }

            if (!message && error.status === 0) {
                // network connectivity issue
                message = 'lost connectivity';
            }

            RivalIQ.logger.warn(`matrixListRow_handleFailures error: ${message}`);

            // NOTE when this view has been destroyed we don't need to bother
            // with triggering a failure method, because the region and its
            // view no longer exist
            if (!me.isDestroyed) {

                _.each(me.getOption('channels'), function (channel) {

                    const region = me[channel.matrixListRowUIKey];
                    const view = region.currentView;
                    view.triggerMethod('failure');
                });
            }
        },

        pollUntilCondition: function (api, condition, options) {

            const me = this;

            const deferred = RivalIQ.utils.polling.pollUntilCondition(api, condition, options);
            deferred.fail(_.bind(me.handleFailures, me));

            return deferred;
        },

        pollForFinderUpdates: function () {

            const me = this;

            const api = function () {

                return $.get(`/api/company/${me.model.id}/channelDiscoveryData`);
            };

            return me.pollUntilCondition(api, function (data) {
                const createStatus = _.get(data, 'create_status');

                return !RivalIQ.utils.createStatus.stillFinding(createStatus);
            }).done(function () {
                // do one last poll of the company data (vs just the channel discovery data) so we load the completed company data
                // NOTE: the skipFailFast is required or the data wont update...
                return me.pollCompanyUntilCondition(function () { return true; }, {
                    skipFailFast: true
                });
            });
        },

        pollCompanyUntilCondition: function (condition, options) {

            const me = this;
            const company = me.model;

            const api = function () {

                const url = `/api/landscapes/${RivalIQ.state.view.get('landscapeId')}/company/${company.id}`;
                const timePeriod = RivalIQ.state.timePeriods.getDefinitionByType(RivalIQ.state.timePeriods.types.LAST_SEVEN_DAYS);

                return $.get(url, {
                    timePeriod: RivalIQ.utils.timePeriod.serializeForAjax(timePeriod)
                });
            };

            const wrappedCondition = function (data) {
                company.set(data);
                return condition();
            };

            return me.pollUntilCondition(api, wrappedCondition, options);
        },

        /**
         * Gets updated company data, and rerenders the item
         */
        onFinderComplete: function () {

            const me = this;
            const company = me.model;
            App.trigger('company:found', company.toJSON());
        }
    });

});
